/********************************************************************************
 * Copyright (c) 2026 CrossBreeze, EclipseSource and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the MIT License which is available in the project root.
 *
 * SPDX-License-Identifier: MIT
 ********************************************************************************/

// Public API barrel — re-exports every PRODUCTION entry of `@hydranium/protocol`.
// `./client` and `./data` are re-exported as well as declared standalone, so a
// consumer wanting the whole production surface needs one specifier while one
// wanting a narrower graph can still name the subpath. `./testing` is excluded
// on the opposite constraint: re-exporting it would put the test doubles in
// every production bundle that imports the root.

export * from './abstract-logger';
export * from './console-logger';
export * from './client';
export * from './client-ids';
export * from './clock';
export * from './data';
export * from './browser-runtime';
export * from './debouncer';
export * from './glsp-edits-settled-actions';
export * from './glsp-request-model-args';
export * from './glsp-save-model-actions';
export * from './errors';
export * from './format-log-arg';
export * from './host-diagnostics';
export * from './logger';
export * from './latency-collector';
// The primitives only. The `./messages` subpath additionally enumerates this
// package's own declarations, which the root barrel already re-exports through
// the modules that raise them.
export * from './messages/primitives';
export * from './patch-merge';
export * from './reconcile-write';
export * from './noop-logger';
export * from './observable-value';
export * from './pending-work-tracker';
export * from './profile-session';
export * from './profiling';
export * from './tracer';
export * from './transfer-diagnostic';
export * from './transfer-element';
export * from './types';
export * from './model-service';
export * from './transfer-document';
export * from './model-server';
export * from './project';
export * from './random-uuid';
export * from './save-text-document';
export * from './rpc';
export * from './uri';
export * from './util';
